import React, { Component } from 'react';
import axios from "axios";
import ApiURL from "../../../api/ApiURL";
import moment from 'moment';
import cogoToast from "cogo-toast";
import { registerAllModules } from "handsontable/registry";
import PageTitle from '../../home/PageTitle';
import LocalStorageHelper from '../../../LocalStorageHelper/LocalStorageHelper';
import TableComponent from "../../common/TableComponent";
import ConfirmModal from "../../common/ConfirmModal";

class VendorPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            UserId: 0,
            UserRole: "",
            finYearId: 0,
            RedirectToLogin: false,
            columns: [],
            vendorPayData: [],
            isTableLoading: false,
            tcData: [],
            locationData: [],
            vendorCategoryData: [],
            vendorData: [],
            bookingTypeData: [],
            vendorPayId: 0,
            travelCircuitId: '0',
            locationId: '0',
            vendorCategoryId: '0',
            vendorId: '0',
            paymentDate: '',
            paidAmount: 0,
            modeOfPayment: '',
            comment: '',
            totalPaidAmount: 0,
            showVendorPayModal: false,
            //----Search Params----
            searchTCData: [],
            searchLocationData: [],
            searchVendorCategoryData: [],
            searchVendorData: [],
            searchTravelCircuitId: '0',
            searchLocationId: '0',
            searchVendorCategoryId: '0',
            searchVendorId: '0',
            searchFromDate: '',
            searchToDate: '',
            disableSearchBtn: false
        };
    }
    //componentDidMount
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                UserId: userData.UserId,
                UserRole: userData.RoleName
            })
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
        this.getAllDataColumns();
        this.getAllTCData();
        this.getAllVendorCategoryData();
    }
    //Get all columns
    getAllDataColumns = () => {
        this.setState({
            columns: [
                {
                    Header: "Action",
                    accessor: "select",
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ row }) => (
                        <div className="text-center" title="Select">
                            <i
                                className="fa-solid fa-pen-to-square"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.getDataItemById(row.original.VendorPayId)}
                            ></i>
                        </div>
                    ),
                },
                { Header: "Vendor", accessor: "VendorName", className: "text-left" },
                { Header: "Vendor Category", accessor: "VendorCategoryName", className: "text-center" },
                {
                    Header: "Payment Date",
                    accessor: "PaymentDate",
                    className: "text-center",
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value ? moment(value).format('DD-MM-YYYY') : ""} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                {
                    Header: "Paid Amount",
                    accessor: "PaidAmount",
                    className: "text-right",
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                { Header: "Mode of Payment", accessor: "ModeOfPayment", className: "text-center" },
                {
                    Header: "Active",
                    accessor: "IsActive",
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value ? (
                                <i className="fa-regular fa-square-check"></i>
                            ) : (
                                <i className="fa-regular fa-square-uncheck"></i>
                            )}
                        </div>
                    ),
                },
            ],
        })
    }
    //Get data by Id
    getDataItemById = (keyData) => {
        console.log(keyData);
        let param = {
            VendorPayId: keyData,
        }
        axios
            .post(ApiURL.GetPaymentToVendor, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    console.log(dataResult);
                    if (dataResult.length > 0) {
                        let data = dataResult[0];
                        this.getAllLocationData(data.TravelCircuitId);
                        this.getAllVendorData(data.LocationId, data.VendorCategoryId);
                        this.setState({
                            vendorPayId: data.VendorPayId,
                            travelCircuitId: data.TravelCircuitId,
                            locationId: data.LocationId,
                            vendorCategoryId: data.VendorCategoryId,
                            vendorId: data.VendorId,
                            paymentDate: data.PaymentDate,
                            paidAmount: data.PaidAmount,
                            modeOfPayment: data.ModeOfPayment,
                            comment: data.Comment,
                            disableSearchBtn: true
                        })
                    }
                    /* this.setState({
                        vendorPayData: dataResult,
                        totalPaidAmount: totalPaid,
                        showVendorPayModal: false
                    }); */
                }
                if (respData.StatusCode === 404) {
                    this.setState({ vendorPayData: [], showVendorPayModal: false });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });

    }
    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        ...this.state,
                        tcData: dataResult,
                        searchTCData: dataResult
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Location data
    getAllLocationData = (tcId) => {
        axios
            .get(ApiURL.GetAllLocationByTC(tcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ locationData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ locationData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Search Location data
    getAllSearchLocationData = (tcId) => {
        axios
            .get(ApiURL.GetAllLocationByTC(tcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ searchLocationData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ locationData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Vendor Category data
    getAllVendorCategoryData = () => {
        axios
            .get(ApiURL.GetAllVendorCategory)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        vendorCategoryData: dataResult,
                        searchVendorCategoryData: dataResult
                    });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ vendorCategoryData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Vendor data
    getAllVendorData = (locId, vcId) => {
        axios
            .get(ApiURL.GetAllVendorByLocation(locId, vcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ vendorData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ vendorData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Search Vendor data
    getAllSearchVendorData = (locId, vcId) => {
        axios
            .get(ApiURL.GetAllVendorByLocation(locId, vcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ searchVendorData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ searchVendorData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //On Change Event Handler
    onChangeHandler = (e) => {
        if (e.target.name === 'travelCircuitId') {
            this.getAllLocationData(e.target.value)
        }
        if (e.target.name === 'locationId') {
            this.getAllVendorData(e.target.value, this.state.vendorCategoryId);
        }
        if (e.target.name === 'vendorCategoryId') {
            this.getAllVendorData(this.state.locationId, e.target.value);
        }
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    //Save Vendor Payment Data
    saveData = (e) => {
        e.preventDefault();
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            let userId = userData.UserId;
            const { vendorPayId, travelCircuitId, locationId, vendorCategoryId, vendorId, paymentDate, paidAmount, modeOfPayment, comment } = this.state;

            if (travelCircuitId === '0') {
                cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
            }
            else if (locationId === '0') {
                cogoToast.error("Location is required!", { position: "bottom-center" });
            }
            else if (vendorCategoryId === '0') {
                cogoToast.error("Vendor Category is required!", { position: "bottom-center" });
            }
            else if (vendorId === '0') {
                cogoToast.error("VendorId is required!", { position: "bottom-center" });
            }
            else if (paymentDate === '') {
                cogoToast.error("Payment date is required!", { position: "bottom-center" });
            }
            else if (paidAmount === 0) {
                cogoToast.error("Paid amount is required!", { position: "bottom-center" });
            }
            else {
                let param = {
                    VendorPayId: vendorPayId,
                    TravelCircuitId: travelCircuitId,
                    LocationId: locationId,
                    VendorCategoryId: vendorCategoryId,
                    VendorId: vendorId,
                    PaymentDate: paymentDate,
                    PaidAmount: paidAmount,
                    ModeOfPayment: modeOfPayment,
                    Comment: comment,
                    UserId: userId,
                    IsActive: true,
                }
                console.log(param);
                axios
                    .post(ApiURL.SaveVendorPayment, param)
                    .then((response) => {
                        let respData = response.data;
                        //console.log(respData);
                        this.resetFormData();
                        if (respData.StatusCode === 200) {
                            cogoToast.success(respData.Message, { position: "bottom-center" });
                        }
                        else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                            cogoToast.warn(respData.Message, { position: "bottom-center" });
                        }
                        else if (respData.StatusCode === 500) {
                            cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                        }
                    })
                    .catch((error) => {
                        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                    });
            }
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
    }
    //Reset Vendor Payment Form Data
    resetFormData = () => {
        this.setState({
            vendorPayData: [],
            finYearId: 0,
            vendorPayId: 0,
            travelCircuitId: '0',
            locationId: '0',
            vendorCategoryId: '0',
            vendorId: '0',
            paymentDate: '',
            paidAmount: 0,
            modeOfPayment: '',
            comment: '',
            disableSearchBtn: false,            
        })
    }
    //Open Vendor Pay modal
    openVendorPayModal = () => {
        this.setState({ showVendorPayModal: true })
    }
    //Close Vendor Pay modal
    closeVendorPayModal = () => {
        this.resetVendorPaySearchData();
        this.setState({ showVendorPayModal: false })
    }
    //Reset Vendor Payment Search Form Data
    resetVendorPaySearchData = () => {
        this.setState({
            searchLocationData: [],
            searchVendorData: [],
            searchTravelCircuitId: '0',
            searchLocationId: '0',
            searchVendorCategoryId: '0',
            searchVendorId: '0',
            searchFromDate: '',
            searchToDate: ''
        })
    }
    //On Change Car Event
    onChangeHandlerSearch = (e) => {
        if (e.target.name === 'searchTravelCircuitId') {
            this.getAllSearchLocationData(e.target.value)
        }
        if (e.target.name === 'searchLocationId') {
            this.getAllSearchVendorData(e.target.value, this.state.searchVendorCategoryId);
        }
        if (e.target.name === 'searchVendorCategoryId') {
            this.getAllSearchVendorData(this.state.searchLocationId, e.target.value);
        }
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    //Search Vendor Payment data
    searchPaymentsToVendor = (e) => {
        e.preventDefault();
        const { vendorPayId, searchVendorId, searchFromDate, searchToDate } = this.state;
        if (this.state.searchVendorId === '0') {
            cogoToast.error("Please select at least one vendor to search for the record!", { position: "bottom-center" });
        }
        else {
            this.resetVendorPaySearchData();
            let param = {
                VendorPayId: vendorPayId,
                VendorId: searchVendorId,
                FromDate: searchFromDate,
                ToDate: searchToDate,
            }
            this.setState({ isTableLoading: true });
            axios
                .post(ApiURL.GetPaymentToVendor, param)
                .then((response) => {
                    let respData = response.data;
                    if (respData.StatusCode === 200) {
                        var dataResult = respData.DataResult;
                        const totalPaid = dataResult.reduce((sum, item) => sum + item.PaidAmount, 0);
                        console.log(dataResult);
                        this.setState({
                            vendorPayData: dataResult,
                            totalPaidAmount: totalPaid,
                            showVendorPayModal: false
                        });
                    }
                    if (respData.StatusCode === 404) {
                        this.setState({ vendorPayData: [], showVendorPayModal: false });
                    }
                    else if (respData.StatusCode === 500) {
                        cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    }
                })
                .catch((error) => {
                    cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                })
                .finally(() => {
                    this.setState({ isTableLoading: false });
                });
        }
    }
    //Render Component life-cycle method
    render() {
        var { columns, vendorPayData, isTableLoading, tcData, locationData, vendorCategoryData, vendorData, travelCircuitId, locationId,
            vendorCategoryId, vendorId, paymentDate, paidAmount, modeOfPayment, comment, totalPaidAmount,
            searchTCData, searchLocationData, searchVendorCategoryData, searchVendorData, searchTravelCircuitId,
            searchLocationId, searchVendorCategoryId, searchVendorId, searchFromDate, searchToDate, disableSearchBtn
        } = this.state;

        return (
            <>
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                        <div className="col-md-6 justify-content-start">
                            <PageTitle Title="Manage Vendor Payment" />
                        </div>
                        <div className="col-md-6 text-right pt-1">
                            <button className="btn btn-outline-primary btn-sm px-3 mr-3" title="Refresh" onClick={this.resetFormData}>
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                            <button className="btn btn-outline-primary btn-sm px-3 mr-3" title="Save" onClick={this.saveData}>
                                <i className="fa-solid fa-save"></i> Save Data
                            </button>
                            {
                                (disableSearchBtn ===true) ?
                                    <button className="btn btn-outline-primary btn-sm px-3" title="Search" disabled>
                                        <i className="fa-solid fa-search"></i> Search
                                    </button> 
                                    :
                                    <button className="btn btn-outline-primary btn-sm px-3" title="Search" onClick={this.openVendorPayModal}>
                                    <i className="fa-solid fa-search"></i> Search
                                </button>
                            }

                        </div>
                    </div>
                </div>
                <div className="container-fluid py-4 mt-115">
                    <div className="card border border-primary mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Travel Circuit</label>
                                        <div className="col-md-8">
                                            <select
                                                name="travelCircuitId"
                                                value={travelCircuitId}
                                                className="form-control-sm border border-primary form-select w-100"
                                                onChange={this.onChangeHandler}
                                            >
                                                <option value="0">-- Select --</option>
                                                {tcData.map((item, index) => (
                                                    <option key={index} value={item.TravelCircuitId}>
                                                        {item.TravelCircuitName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Location</label>
                                        <div className="col-md-8">
                                            <select
                                                name="locationId"
                                                value={locationId}
                                                className="form-control-sm border border-primary form-select w-100"
                                                onChange={this.onChangeHandler}
                                            >
                                                <option value="0">-- Select --</option>
                                                {locationData.map((item, index) => (
                                                    <option key={index} value={item.LocationId}>
                                                        {item.LocationName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Vendor Category</label>
                                        <div className="col-md-8">
                                            <select
                                                className="form-control-sm border border-primary form-select w-100"
                                                name="vendorCategoryId"
                                                value={vendorCategoryId}
                                                onChange={this.onChangeHandler}
                                            >
                                                <option value="0">-- Select --</option>
                                                {vendorCategoryData.map((item, index) => (
                                                    <option key={index} value={item.VendorCategoryId}>
                                                        {item.VendorCategoryName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Vendor</label>
                                        <div className="col-md-8">
                                            <select
                                                name="vendorId"
                                                value={vendorId}
                                                className="form-control-sm border border-primary form-select w-100"
                                                onChange={this.onChangeHandler}
                                            >
                                                <option value="0">-- Select --</option>
                                                {vendorData.map((item, index) => (
                                                    <option key={index} value={item.VendorId}>
                                                        {item.VendorName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Payment Date</label>
                                        <div className="col-md-8">
                                            <input type="date"
                                                name="paymentDate"
                                                className="form-control-sm border border-primary w-100"
                                                value={paymentDate}
                                                onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Paid Amount</label>
                                        <div className="col-md-8">
                                            <input type="number"
                                                name="paidAmount"
                                                className="form-control-sm border border-primary w-100"
                                                value={paidAmount}
                                                onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Mode of Payment</label>
                                        <div className="col-md-8">
                                            <select
                                                name="modeOfPayment"
                                                className="form-control-sm border border-primary form-select w-100"
                                                value={modeOfPayment}
                                                onChange={this.onChangeHandler}>
                                                <option value="">-- Select --</option>
                                                <option value="Cash">Cash</option>
                                                <option value="Cheque">Cheque</option>
                                                <option value="UPI">UPI</option>
                                                <option value="NEFT">NEFT</option>
                                                <option value="RTGS">RTGS</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="form-group row">
                                        <label className="col-md-2 col-form-label-sm border border-primary bg-primary-subtle">Comment</label>
                                        <div className="col-md-10">
                                            <input type="text"
                                                name="comment"
                                                className="form-control-sm border border-primary w-100"
                                                value={comment}
                                                onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    (vendorPayData.length > 0 || isTableLoading) &&
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">

                                <TableComponent columns={columns} data={vendorPayData} isLoading={isTableLoading} />

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {/* <table className="table table-bordered table-striped table-condensed cf"> */}
                                <table className="table table-striped table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ fontSize: '15px' }}>Total Amount Paid to Vendor</td>
                                            <td className='text-right' style={{ fontSize: '15px' }}>{totalPaidAmount.toFixed(2)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                }

                {/* <!-- Search vendor payment modal section--> */}
                <div className={this.state.showVendorPayModal === true ? "modal show-modal  modalWrapper" : "modal"}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    Search Vendor Payment
                                </h3>
                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeVendorPayModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row p-3">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Travel Circuit</label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="searchTravelCircuitId"
                                                            value={searchTravelCircuitId}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            onChange={this.onChangeHandlerSearch}
                                                        >
                                                            <option value="0">-- Select --</option>
                                                            {searchTCData.map((item, index) => (
                                                                <option key={index} value={item.TravelCircuitId}>
                                                                    {item.TravelCircuitName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Location</label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="searchLocationId"
                                                            value={searchLocationId}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            onChange={this.onChangeHandlerSearch}
                                                        >
                                                            <option value="0">-- Select --</option>
                                                            {searchLocationData.map((item, index) => (
                                                                <option key={index} value={item.LocationId}>
                                                                    {item.LocationName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Vendor Catg.</label>
                                                    <div className="col-md-8">
                                                        <select
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            name="searchVendorCategoryId"
                                                            value={searchVendorCategoryId}
                                                            onChange={this.onChangeHandlerSearch}
                                                        >
                                                            <option value="0">-- Select --</option>
                                                            {searchVendorCategoryData.map((item, index) => (
                                                                <option key={index} value={item.VendorCategoryId}>
                                                                    {item.VendorCategoryName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Vendor</label>
                                                    <div className="col-md-8">
                                                        <select
                                                            name="searchVendorId"
                                                            value={searchVendorId}
                                                            className="form-control-sm border border-primary form-select w-100"
                                                            onChange={this.onChangeHandlerSearch}
                                                        >
                                                            <option value="0">-- Select --</option>
                                                            {searchVendorData.map((item, index) => (
                                                                <option key={index} value={item.VendorId}>
                                                                    {item.VendorName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">From Date</label>
                                                    <div className="col-md-8">
                                                        <input type="date"
                                                            name="searchFromDate"
                                                            className="form-control-sm border border-primary w-100"
                                                            value={searchFromDate}
                                                            onChange={this.onChangeHandlerSearch} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group row">
                                                    <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">To Date</label>
                                                    <div className="col-md-8">
                                                        <input type="date"
                                                            name="searchToDate"
                                                            className="form-control-sm border border-primary w-100"
                                                            value={searchToDate}
                                                            onChange={this.onChangeHandlerSearch} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button className="btn btn-success button-box-shadow" onClick={this.searchPaymentsToVendor}>
                                    <i className="fa-solid fa-circle-check"></i> Search
                                </button>

                                <button className="btn btn-secondary button-box-shadow" onClick={this.closeVendorPayModal}>
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--  Search vendor payment modal section--> */}

            </>
        );
    }
}

export default VendorPayment;